import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort } from '@angular/material/sort';
import { map } from 'rxjs/operators';
import { Observable, of as observableOf, merge } from 'rxjs';
export class TagsListDataSource extends DataSource<any> {
  data: Array<any>;
  paginator: MatPaginator;
  sort: MatSort;
  nonFilteredData;

  constructor(private tags: Array<any>) {
    super();
    this.data = tags;
    this.nonFilteredData = tags;
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(): Observable<any[]> {
    // Combine everything that affects the rendered data into one update
    // stream for the data-table to consume.
    const dataMutations = [
      observableOf(this.data),
      this.paginator.page,
      this.sort.sortChange
    ];

    return merge(...dataMutations).pipe(map(() => {
      return this.getPagedData(this.getSortedData([...this.data]));
    }));
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect() { }

  /**
   * Paginate the data (client-side). If you're using server-side pagination,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getPagedData(data: any[]) {
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    return data.splice(startIndex, this.paginator.pageSize);
  }

  /**
   * Sort the data (client-side). If you're using server-side sorting,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getSortedData(data: any[]) {
    if (!this.sort.active || this.sort.direction === '') {
      return data;
    }

    return data.sort((a, b) => {
      const isAsc = this.sort.direction === 'asc';
      switch (this.sort.active) {
        case 'name': return compare(a.name, b.name, isAsc);
        case 'createdDate': return compare(+a.createdDate, +b.createdDate, isAsc);
        case 'createdBy': return compare(a.createdBy?.firstName, b.createdBy?.firstName, isAsc);
        default: return 0;
      }
    });
  }

  filter(field: any, fullData: any) {
    let filterData: any[] = fullData;
    if (field['tagName']) {
      filterData = filterData.filter(x => {
        return x.name.toLocaleLowerCase().indexOf(field['tagName'].toLocaleLowerCase()) > -1;
      });
    }
    if (field['createdBy']) {
      filterData = filterData.filter(x => {
        return x.createdByEmployeeId == field['createdBy'];
      });
    }
    return filterData;
  }

}
/** Simple sort comparator for example ID/Name columns (for client-side sorting). */
function compare(a: string | number, b: string | number, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
